import * as types from '../actions/types'

const initialState = {
  tracks: [],
  chapterSearch: ''
}

export default function (state=initialState, action) {

  switch (action.type) {
    case types.RECEIVE_TRACKS:
      // If there were no tracks returned, set the state to an empty array
      return {
        tracks: action.response || [],
        chapterSearch: ''
      }

    case types.SET_TRACK_CACHED:
      return Object.assign({}, state, {
        tracks: state.tracks.map((track) => track.id === action.track.id ? {...track, cached: true} : track)
      })

    case types.CHAPTER_SEARCH:
      return Object.assign({}, state, {
        chapterSearch: action.chapter
      })

    default:
      return state
  }
}

export const getVisibleTracks = (state) => {
  if (state.chapterSearch === '' || !state.chapterSearch)
    return state.tracks

  return state.tracks.filter(track => track.chapter.toString().indexOf(state.chapterSearch.toString()) !== -1)
}
// {...state, isPlaying: true} is same as:
// Object.assign({}, state, {
//   isPlaying: true
// })



// WEBPACK FOOTER //
// ./src/reducers/tracks.js